import { useState } from 'react';

import { Cog } from 'lucide-react';
import { Select, Col, FormGroup, Label, Row, Input, DefaultSheet, SheetBody, Button } from 'twyne-new.ui';

import CodeEditor from '@Components/form/CodeEditor';
// import { sass } from '@Utils/sass';

const COLS_ROWS_OPTIONS = [
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
]

const TEMPLATE_TYPES = [
  { value: 'button-and-dropdown', label: 'Button + Dropdown' },
  { value: 'only-buttons', label: 'Only Buttons' },
  { value: 'only-dropdown', label: 'Only Dropdown' },
]

export default function Config({ data, onChange, disabled }) {
  const [openConfig, setOpenConfig] = useState(false);

  const handleToogle = () => {
    setOpenConfig(open => !open);
  }

  const handleChangeCSS = value => {
    onChange('scss', value);
    // sass.compile(`.tcpa-questionary-custom{${value}}`, ({ status, text }) => {
    //   if (status === 0) {
    //     onChange('css', text);
    //   }
    // })
  }

  return <>
    <Row>
      <Col size="12">
        <Button color='accent' variant='outline' className="mt-2 float-right" type="button" onClick={handleToogle}>
          Configure
          <Cog size={16} />
        </Button>
      </Col>
    </Row>
    <DefaultSheet
      wrapperProps={{ open: openConfig, onOpenChange: open => !open && handleToogle() }}
      title='Template Config'
    >
      <SheetBody>
        <Row>
          <Col size="4">
            <FormGroup>
              <Label>Type</Label>
              <Select
                disabled={disabled}
                clearable={false}
                name="templateType"
                value={data.templateType || ''}
                options={TEMPLATE_TYPES}
                onChange={option => onChange('templateType', option.value)}
              />
            </FormGroup>
          </Col>
          <Col size="4">
            <FormGroup>
              <Label>Button Padding</Label>
              <Select
                disabled={disabled}
                clearable={true}
                name="cols"
                value={data?.buttonPadding || null}
                options={COLS_ROWS_OPTIONS}
                onChange={option => onChange('buttonPadding', option?.value)}
              />
            </FormGroup>
          </Col>
          {data.templateType !== 'only-dropdown' && <>
            <Col size="2">
              <FormGroup>
                <Label>Cols</Label>
                <Select
                  disabled={disabled}
                  clearable={false}
                  name="cols"
                  value={data.templateCols || 2}
                  options={COLS_ROWS_OPTIONS}
                  onChange={option => onChange('templateCols', option.value)}
                />
              </FormGroup>
            </Col>
            {data.templateType !== 'only-buttons' && <Col size="2">
              <FormGroup>
                <Label>Rows</Label>
                <Select
                  disabled={disabled}
                  clearable={false}
                  name="rols"
                  value={data.templateRows || 2}
                  options={COLS_ROWS_OPTIONS}
                  onChange={option => onChange('templateRows', option.value)}
                />
              </FormGroup>
            </Col>}
          </>}
          <Col size="4">
            <FormGroup>
              <Label>Horizontal Padding</Label>
              <Input
                disabled={disabled}
                value={data.horizontalPadding}
                onChange={e => onChange('horizontalPadding', e.target.value)} />
            </FormGroup>
          </Col>
          <Col size="12">
            <FormGroup>
              <Label>css</Label>
              <CodeEditor
                disabled={disabled}
                height="200px"
                name="scss"
                language="css"
                value={data.scss}
                onChange={handleChangeCSS}
              />
            </FormGroup>
          </Col>
        </Row>
      </SheetBody>
    </DefaultSheet>
  </>
}
